import React, { useState } from 'react'
import { ChevronsLeftRight } from 'lucide-react'

/**
 * Wipe slider primitive for comparing two photos.
 * Drag the divider line (or anywhere on the image) to reveal more of one or the other.
 */
export function PhotoComparisonSlider({ beforeUrl, afterUrl, beforeLabel, afterLabel }) {
  const [pos, setPos] = useState(50)

  if (!beforeUrl || !afterUrl) return null

  return (
    <div dir="ltr" className="relative w-full aspect-[3/4] overflow-hidden rounded-lg bg-black select-none">
      {/* Bottom (before) image */}
      <img
        src={beforeUrl}
        alt={beforeLabel || 'Before'}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        draggable={false}
      />

      {/* Top (after) image, clipped */}
      <img
        src={afterUrl}
        alt={afterLabel || 'After'}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
      />

      {/* Vertical divider line + handle */}
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-white pointer-events-none shadow-[0_0_10px_rgba(0,0,0,0.5)]"
        style={{ left: `${pos}%` }}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white border-2 border-app-primary-500 flex items-center justify-center shadow-lg">
          <ChevronsLeftRight className="w-5 h-5 text-app-primary-500" />
        </div>
      </div>

      {/* Top corner labels */}
      {beforeLabel && (
        <div className="absolute top-2 left-2 px-2 py-1 rounded bg-black/70 text-white text-xs font-mono pointer-events-none">
          {beforeLabel}
        </div>
      )}
      {afterLabel && (
        <div className="absolute top-2 right-2 px-2 py-1 rounded bg-black/70 text-white text-xs font-mono pointer-events-none">
          {afterLabel}
        </div>
      )}

      {/* Transparent range input handles all interaction (touch + keyboard + mouse) */}
      <input
        type="range"
        min="0"
        max="100"
        step="0.1"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        aria-label="Comparison slider"
      />
    </div>
  )
}
